import React, { useEffect, useState } from 'react'
import styles from "../offlinePay.module.css";
import OfflineRemitterForm from './OfflineRemitterForm';
import OfflineRemitterDocs from './OfflineRemitterDocs';
import { fetchDetails, statusApi } from '../../../api';
import { useMyContext } from '../../../myContext';
import { Spinner } from 'react-bootstrap';

function OfflineRemitter({stepToShowOffline, setStepToShowOffline}) {
  const [loading, setLoading] = useState(false);
  const [remitterList, setRemitterList] = useState([]);
  const [remitterDetail, setRemitterDetail] = useState();
  const [documentUploaded, setDocumentUploaded] = useState(false);
  const {setOfflineRemitterUserId, themeColor} = useMyContext();

  useEffect(() => {
    fetchRemitterData();
  },[])

  const fetchRemitterDetail = async(id) => {
    try{
      const resp = await statusApi(id);
      setLoading(false);
      setRemitterDetail(resp?.data);
      if(resp?.data?.aadhaarStatus === "APPROVED" && resp?.data?.panStatus === "APPROVED")
      setDocumentUploaded(true)
    }
    catch(e){
      setLoading(false);
    }
  }

  const fetchRemitterData = async () => {
    setLoading(true);
    try {
      fetchDetails("remitter").then((response) => {
        if(response?.data.length > 0){
          setRemitterList(response?.data);
          fetchRemitterDetail(response?.data[0].userAccountId);
          setOfflineRemitterUserId(response?.data[0].userAccountId);
          // setDocumentUploaded(true)
        }else{
          setLoading(false);
        }
      });
    } catch (error) {
      setLoading(false);
    }
  };

  return (
    <div className={styles.cardDetails}>
    <>
      <h1 className={styles.onboardHeading}>1. Remitter</h1>
      {loading ? <Spinner animation="border" className={styles.spinnerColorOutside} style={{borderColor: themeColor, borderRightColor: "#eaecf0"}}/> : 
    <>
      <OfflineRemitterForm stepToShowOffline={stepToShowOffline} setStepToShowOffline={setStepToShowOffline} remitterList={remitterList} documentUploaded={documentUploaded} remitterDetail={remitterDetail}/>
      {!documentUploaded && <OfflineRemitterDocs stepToShowOffline={stepToShowOffline} setStepToShowOffline={setStepToShowOffline}/>}
      </>}
      </>
      </div>
  )
}

export default OfflineRemitter